import { render } from "./argentina.vue?vue&type=template&id=6bbfe6be&scoped=true"
import script from "./argentina.vue?vue&type=script&lang=js"
export * from "./argentina.vue?vue&type=script&lang=js"

import "./argentina.vue?vue&type=style&index=0&id=6bbfe6be&lang=scss&scoped=true"
import "./argentina.vue?vue&type=style&index=1&id=6bbfe6be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bbfe6be"

export default script